import { Check } from 'lucide-react'
import { Button } from './ui/Button'

export default function PricingSection() {
  const plans = [
    {
      name: 'Starter',
      price: 'Miễn phí',
      highlight: 'Phù hợp CLB nhỏ và thử nghiệm',
      features: ['Tạo giải cơ bản', 'Quản lý thành viên', 'Lịch thi đấu cơ bản'],
      featured: false,
    },
    {
      name: 'Pro',
      price: '299.000₫/tháng',
      highlight: 'Đầy đủ tính năng cho tổ chức chuyên nghiệp',
      features: ['Bốc thăm tự động', 'Thông báo real-time', 'Thống kê nâng cao', 'Hỗ trợ ưu tiên'],
      featured: true,
    },
    {
      name: 'Enterprise',
      price: 'Liên hệ',
      highlight: 'Tuỳ chỉnh sâu cho liên đoàn/giải lớn',
      features: ['Triển khai riêng', 'Tích hợp hệ thống', 'Đào tạo & tư vấn'],
      featured: false,
    },
  ]

  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-white to-neutral-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-mebi-yellow-100 rounded-full mb-6">
              <span className="text-sm font-medium text-mebi-yellow-700">Bảng giá</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900">Chọn gói phù hợp</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {plans.map((p, i) => (
              <div
                key={i}
                className={`rounded-2xl border ${p.featured ? 'border-mebi-yellow-400 bg-gradient-to-br from-mebi-yellow-50 to-white shadow-xl' : 'border-neutral-200 bg-white'} p-6`}
              >
                <div className="mb-4">
                  <h3 className="text-xl font-bold text-neutral-900">{p.name}</h3>
                  <p className="text-sm text-neutral-600">{p.highlight}</p>
                </div>
                <p className="text-2xl font-bold text-neutral-900 mb-4">{p.price}</p>
                <ul className="space-y-2 mb-6">
                  {p.features.map((f, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-neutral-700">
                      <Check className="w-4 h-4 text-mebi-yellow-600" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <Button variant={p.featured ? 'primary' : 'secondary'} className="w-full">{p.featured ? 'Dùng thử ngay' : 'Liên hệ'}</Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}